<p-toast [style]="{marginTop: '80px'}"></p-toast>
<p-confirmDialog header="Confirmation" icon="pi pi-exclamation-triangle"></p-confirmDialog>

<p-table class="maintenance-table" #pt [value]="maintenanceEvents" [lazy]="true" (onLazyLoad)="loadLazy($event)" dataKey="maintenanceEventId" selectionMode="single"
  [(selection)]="maintenanceEvent" (onRowSelect)="onRowSelect($event)" [loading]="loading" [paginator]="showPagination" [rows]="25"
  [rowsPerPageOptions]="[25,100,200]" showCurrentPageReport="true"
  currentPageReportTemplate="{totalRecords} results. Page {currentPage} of {totalPages}" [totalRecords]="recordTotal"
  sortMode="multiple" [multiSortMeta]="multiSortMeta" styleClass="p-datatable-striped" [ngStyle]="{'width': 'auto'}"
  [resizableColumns]="true" [autoLayout]="true" [responsive]="true">

  <ng-template pTemplate="caption">
    <div class="d-block text-end justify-content-between align-items-center">
      <h1 style="float: left;margin: 6px;">Maintenance Events</h1>
      <span>
        <!--clear filters-->
        @if (showFilter) {
          <button pButton pRipple class="p-button-text"
            style="font-size: 80%; padding: 0.643rem 0.75rem !important; margin-right:10px;"
          (click)="reloadPage()">Clear Filters</button>
        }

        <!--add new-->
        <button pButton pRipple class="p-button" style="padding: 0.643rem 0.75rem !important;"
        (click)="onOpenFormAdd()">New Maintenance Event +</button>
      </span>
    </div>
  </ng-template>
  <ng-template pTemplate="header">
    <tr>
      @for (col of columns; track col) {
        <th [pSortableColumn]="col.field" [ngStyle]="{'width': 'auto'}">
          {{col.header}}
          <p-sortIcon [field]="col.field"></p-sortIcon>
        </th>
      }
      <th [ngStyle]="{'width': 'auto'}"></th>
    </tr>
    @if (showFilter) {
      <tr>
        <th [ngStyle]="{'width': 'auto'}"><input [ngStyle]="{'width':'50px','min-width':'100%'}" pInputText type="text" (input)="pt.filter($event.target.value, 'maintenanceEventId', 'in')"></th>
        <th [ngStyle]="{'width': 'auto'}"><input [ngStyle]="{'width':'50px','min-width':'100%'}" pInputText type="text" (input)="pt.filter($event.target.value, 'name', 'in')"></th>
        <th [ngStyle]="{'width': 'auto'}"><input [ngStyle]="{'width':'50px','min-width':'100%'}" pInputText type="text" (input)="pt.filter($event.target.value, 'description', 'in')"></th>
        <th [ngStyle]="{'width': 'auto'}"><input [ngStyle]="{'width':'50px','min-width':'100%'}" pInputText type="text" (input)="pt.filter($event.target.value, 'impactDesc', 'in')"></th>
        <th [ngStyle]="{'width': 'auto'}"><input [ngStyle]="{'width':'50px','min-width':'100%'}" pInputText type="text" (input)="pt.filter($event.target.value, 'resolutionDesc', 'in')"></th>
        <th>
          <p-dropdown #aa [style]="{'width':'50px','min-width':'100%'}" [options]="resolutions" appendTo="body"
            (onChange)="pt.filter($event.value, 'resolution', 'in')" styleClass="p-column-filter"
            placeholder="Filter" [showClear]="true" optionLabel="name" optionValue="value">
            <ng-template let-option pTemplate="item">
              <span>{{option.name}}</span>
            </ng-template>
          </p-dropdown>
        </th>
        <!-- <th [ngStyle]="{'width': 'auto'}"><input [ngStyle]="{'width':'50px','min-width':'100%'}" pInputText type="text" (input)="pt.filter($event.target.value, 'guestPriorNotifDaysNum', 'in')"></th> -->
        <th [ngStyle]="{'width': 'auto'}"><input [ngStyle]="{'width':'50px','min-width':'100%'}" pInputText type="text" (input)="pt.filter($event.target.value, 'opsNotes', 'in')"></th>
        <th [ngStyle]="{'width': 'auto'}"><input [ngStyle]="{'width':'50px','min-width':'100%'}" pInputText type="text" (input)="pt.filter($event.target.value, 'startDate', 'in')"></th>
        <th [ngStyle]="{'width': 'auto'}"><input [ngStyle]="{'width':'50px','min-width':'100%'}" pInputText type="text" (input)="pt.filter($event.target.value, 'endDate', 'in')"></th>
        <!-- <th [ngStyle]="{'width': 'auto'}"><input [ngStyle]="{'width':'50px','min-width':'100%'}" pInputText type="text" (input)="pt.filter($event.target.value, 'startTime', 'in')"></th>
        <th [ngStyle]="{'width': 'auto'}"><input [ngStyle]="{'width':'50px','min-width':'100%'}" pInputText type="text" (input)="pt.filter($event.target.value, 'endTime', 'in')"></th> -->
        <th>
          <!-- <p-dropdown #aa [style]="{'width':'50px','min-width':'100%'}" [options]="statuses"
          (onChange)="pt.filter($event.value, 'status', 'in')" styleClass="p-column-filter"
          placeholder="Filter" [showClear]="true" optionLabel="name" optionValue="value">
          <ng-template let-option pTemplate="item">
            <span>{{option.name}}</span>
          </ng-template>
        </p-dropdown> -->
      </th>
      <th>
        <p-dropdown #aa [style]="{'width':'50px','min-width':'100%'}" [options]="visibilities" appendTo="body"
          (onChange)="pt.filter($event.value, 'visibility', 'in')" styleClass="p-column-filter"
          placeholder="Filter" [showClear]="true" optionLabel="name" optionValue="value">
          <ng-template let-option pTemplate="item">
            <span>{{option.name}}</span>
          </ng-template>
        </p-dropdown>
      </th>
      <th [ngStyle]="{'width': 'auto'}"><input [ngStyle]="{'width':'50px','min-width':'100%'}" pInputText type="text" (input)="pt.filter($event.target.value, 'maintenanceEventShortTermRentalVOList.propertyCode', 'in')"></th>
      <th [ngStyle]="{'width': 'auto'}"><input [ngStyle]="{'width':'50px','min-width':'100%'}" pInputText type="text" (input)="pt.filter($event.target.value, 'floorOfProperty', 'in')"></th>
      <th [ngStyle]="{'width': 'auto'}"><input [ngStyle]="{'width':'50px','min-width':'100%'}" pInputText type="text" (input)="pt.filter($event.target.value, 'adrBuildingName', 'in')"></th>
      <th [ngStyle]="{'width': 'auto'}"><input [ngStyle]="{'width':'50px','min-width':'100%'}" pInputText type="text" (input)="pt.filter($event.target.value, 'developmentId', 'in')"></th>
      <th [ngStyle]="{'width': 'auto'}"></th>
    </tr>
  }
</ng-template>
<ng-template pTemplate="body" let-maintenanceEvent>
  <tr [pSelectableRow]="maintenanceEvent">
    <td>{{maintenanceEvent?.maintenanceEventId}} </td>
    <td class="table-head">{{maintenanceEvent?.name}}</td>
    <td><p [innerHTML]="maintenanceEvent.description"></p></td>
    <td><p>{{maintenanceEvent?.impactDesc}}</p></td>
    <td><p>{{maintenanceEvent?.resolutionDesc}}</p></td>
    <td>{{getResolution(maintenanceEvent)}}</td>
    <!-- <td>{{maintenanceEvent.guestPriorNotifDaysNum}}</td> -->
    <td><p>{{maintenanceEvent?.opsNotes}}</p></td>
    <td>{{maintenanceEvent?.startDate | date}}</td>
    <td>{{maintenanceEvent?.endDate | date}}</td>
    <!-- <td>{{maintenanceEvent.startTime}}</td>
    <td>{{maintenanceEvent.endTime}}</td> -->
    <td>{{checkDate(maintenanceEvent?.startDate, maintenanceEvent?.endDate)}}</td>
    <td>{{getVisibility(maintenanceEvent?.visibility)}}</td>
    <td>{{getPropertyCodes(maintenanceEvent)}}</td>
    <td>{{maintenanceEvent?.floorOfProperty}}</td>
    <td>{{maintenanceEvent?.adrBuildingName}}</td>
    <td>{{maintenanceEvent?.developmentId}}</td>
    <td><span style="float:none">
      <a>
        <i class="pi pi-pencil" aria-hidden="true"
        style="color:blue; font-size:110%; padding-right:20px;" (click)="onOpenFormEdit(maintenanceEvent)"></i>
      </a>
    </span>
  </td>
</tr>
</ng-template>
</p-table>